import { Component, Inject, OnInit } from '@angular/core';
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-shop-reward-bottomsheet',
  templateUrl: './shop-reward-bottomsheet.component.html',
  styleUrls: ['./shop-reward-bottomsheet.component.scss'],
})
export class ShopRewardBottomsheetComponent implements OnInit {
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };
  text: string;
  options: AnimationOptions = {
    path:
      this.data.type === 'success'
        ? '/assets/animations/paperWork .json'
        : '/assets/animations/paperWorkSheypoor.json',
    loop: true,
  };

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: { type: 'reward' | 'success'; title: string },
    private bottomSheetRef: MatBottomSheetRef<ShopRewardBottomsheetComponent>
  ) {}
  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.bottomSheetRef.dismiss();
    }
  }
  goBack() {
    this.bottomSheetRef.dismiss();
  }
  animationCreated(animationItem: AnimationItem): void {}

  ngOnInit(): void {
    if (this.data.type == 'reward') {
      this.text = `کد هدیه با موفقیت ثبت شد و ${this.data.title} ماه اشتراک دریافت کردید. حالا می‌توانید از تمام امکانات بنتو استفاده کنید.`;
    } else {
      this.text = `اشتراک ${this.data.title} ماهه بنتو برای شما فعال شد. حالا می‌توانید از تمام امکانات بنتو استفاده کنید.`;
    }
  }
}
